<template>
  <div class="filter-widget">
    <h2 class="widget-title toggle-item" :class="{active: active}" @click="active=!active"><span></span>{{$t("shop.sidebar."+filter.title)}}</h2>
    <div class="widget-listing-box" v-show="['md', 'lg', 'xl', 'hd', 'inf'].includes($mq) || active">
      <div
              class="widget-listing"
              v-for="(category, category_key) in filter.categories"
              :key="category_key"
      >
        <h3
                class="listing-title"
                :class="{'has-options': category.options.length, opened: category.open}"
                @click="select_category(category, {slug: null})"
        >{{category.title[$i18n.locale] || category.title.en}}</h3>
        <ul class="listing" v-if="category.open && category.options.length">
          <li v-for="(option, option_key) in category.options" :key="option_key">
            <input
                    type="radio"
                    :name="'filter-'+category.id"
                    @change="select_category(category, option)"
                    value="true"
                    v-model="option.selected"
                    :id="'check'+option.id"
            />
            <label :for="'check'+option.id">{{option.name}}</label>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['filter'],
  data () {
    return {
      active: false
    }
  },
  methods: {
    select_category (taxonomy, term) {
      this.$router.push({
        name: 'shop',
        params: {
          lang: this.$i18n.locale,
          taxonomy: taxonomy.slug,
          term: term.slug
        }
      })
    },
    show_all (category) {
      this.$router.push({
        name: 'shop',
        params: {
          taxonomy: category.slug
        }
      })
    }
  }
}
</script>
